import React from 'react'
import './App.css'
import AppRouter from './router'
import { ClaimProvider } from './claimProvider'
/*
 test
*/
function App() {
    return (
        <ClaimProvider>
            <div className="App">
                <AppRouter />
            </div>
        </ClaimProvider>
    )
}

export default App
